import { assertIsDefined } from '~/types/assert-type';

export class ResourceNameIdConverter {
  static reservoirNameToId(reservoirName: string): string {
    const match = reservoirName.match(/\/reservoirs\/([^/]+)/);

    assertIsDefined(match);
    return match[1];
  }

  static drainNameToId(drainName: string): string {
    const match = drainName.match(/\/drains\/([^/]+)/);

    assertIsDefined(match);
    return match[1];
  }

  static productNameToId(productName: string): string {
    const match = productName.match(/\/products\/([^/]+)/);

    assertIsDefined(match);
    return match[1];
  }

  static deviceNameToId(deviceName: string): string {
    const match = deviceName.match(/\/devices\/([^/]+)/);

    assertIsDefined(match);
    return match[1];
  }

  static systemIdToName(systemId: string): string {
    return `systems/${systemId}`;
  }

  static systemNameToId(systemName: string): string {
    const match = systemName.match(/systems\/([^/]+)/);

    assertIsDefined(match);
    return match[1];
  }
}
